import { __, invertObj, prop } from 'ramda';

import { DocumentType } from '../../../types/document';

enum PrismicDocumentType {
  COLD_ARTICLE = 'cold_article',
  CONTACT = 'contact',
  FINANCIAL_DEBT = 'financial_debt',
  FINANCIAL_KEY_FIGURES = 'financial_key_figures',
  FINANCIAL_PRESS_RELEASE = 'financial_press_release',
  FINANCIAL_PUBLICATION = 'financial_publication',
  FINANCIAL_RATING = 'financial_rating',
  FOOTER = 'footer',
  HEADER = 'header',
  HOME = 'home_page',
  HUB_ACTUS = 'hub_actus',
  HUB_NEWSROOM = 'hub_newsroom',
  HOT_ARTICLE = 'hot_article',
  LA_POSTE_EN_4 = 'la_poste_en_4',
  MEDIA_POPIN = 'media_popin',
  MEDIA_PRESS = 'media_presse_v2',
  NEWSROOM = 'newsroom',
  PRESS_RELEASE = 'press_release',
  PROFILE = 'profile',
  SEARCH = 'search_page',
  SLIDER_POPIN = 'slider_popin',
  RSE = 'rse',
  TIMELINE_POPIN = 'timeline_popin',
}

const PRISMIC_TO_TYPE_DOCUMENT = {
  [PrismicDocumentType.COLD_ARTICLE]: DocumentType.COLD_ARTICLE,
  [PrismicDocumentType.CONTACT]: DocumentType.CONTACT,
  [PrismicDocumentType.FINANCIAL_DEBT]: DocumentType.FINANCIAL_DEBT,
  [PrismicDocumentType.FINANCIAL_KEY_FIGURES]:
    DocumentType.FINANCIAL_KEY_FIGURES,
  [PrismicDocumentType.FINANCIAL_PRESS_RELEASE]:
    DocumentType.FINANCIAL_PRESS_RELEASE,
  [PrismicDocumentType.FINANCIAL_PUBLICATION]:
    DocumentType.FINANCIAL_PUBLICATION,
  [PrismicDocumentType.FINANCIAL_RATING]: DocumentType.FINANCIAL_RATING,
  [PrismicDocumentType.FOOTER]: DocumentType.FOOTER,
  [PrismicDocumentType.HEADER]: DocumentType.HEADER,
  [PrismicDocumentType.HOME]: DocumentType.HOME,
  [PrismicDocumentType.HOT_ARTICLE]: DocumentType.HOT_ARTICLE,
  [PrismicDocumentType.HUB_ACTUS]: DocumentType.HUB_ACTUS,
  [PrismicDocumentType.HUB_NEWSROOM]: DocumentType.HUB_NEWSROOM,
  [PrismicDocumentType.LA_POSTE_EN_4]: DocumentType.LA_POSTE_EN_4,
  [PrismicDocumentType.MEDIA_POPIN]: DocumentType.MEDIA_POPIN,
  [PrismicDocumentType.MEDIA_PRESS]: DocumentType.MEDIA_PRESS,
  [PrismicDocumentType.NEWSROOM]: DocumentType.NEWSROOM,
  [PrismicDocumentType.PRESS_RELEASE]: DocumentType.PRESS_RELEASE,
  [PrismicDocumentType.PROFILE]: DocumentType.PROFILE,
  [PrismicDocumentType.SEARCH]: DocumentType.SEARCH,
  [PrismicDocumentType.SLIDER_POPIN]: DocumentType.SLIDER_POPIN,
  [PrismicDocumentType.RSE]: DocumentType.RSE,
  [PrismicDocumentType.TIMELINE_POPIN]: DocumentType.TIMELINE_POPIN,
};

const TYPE_DOCUMENT_TO_PRISMIC = {
  ...(invertObj(PRISMIC_TO_TYPE_DOCUMENT) as Record<
    DocumentType,
    PrismicDocumentType
  >),
  [DocumentType.MEDIA_PRESS_RELEASE]: PrismicDocumentType.MEDIA_PRESS,
};

export const toDocType = prop(__, PRISMIC_TO_TYPE_DOCUMENT);
export const toDocPrismic = prop(__, TYPE_DOCUMENT_TO_PRISMIC);
